import {
  mdiAccountOutline,
  mdiClipboardEditOutline,
  mdiOfficeBuildingOutline,
  mdiThumbDownOutline,
  mdiThumbUpOutline,
  mdiTimerSand,
} from '@mdi/js';

const APPROVAL_KEY = Object.freeze({
  APPROVED: 'APPROVED',
  COMPLETED: 'COMPLETED',
  REJECTED: 'REJECTED',
  TODO: 'TODO',
  WALLET_FAILED: 'WALLET_FAILED',
});

const APPROVAL_STATUS_CONFIG = Object.freeze({
  [APPROVAL_KEY.APPROVED]: { color: 'blue', i18nKey: 'myAccount.requestApproved' },
  [APPROVAL_KEY.COMPLETED]: { color: 'green', i18nKey: 'myAccount.requestCompleted' },
  [APPROVAL_KEY.REJECTED]: { color: 'red', i18nKey: 'myAccount.requestRejected' },
  [APPROVAL_KEY.TODO]: { color: 'orange', i18nKey: 'myAccount.requestPending' },
  [APPROVAL_KEY.WALLET_FAILED]: { color: 'purple', i18nKey: 'myAccount.walletCreationFailed' },
});

const DOCUMENT = Object.freeze({
  TYPE: {
    DRIVERS_LICENSE_BACK: 'drivers_license_back',
    DRIVERS_LICENSE_FRONT: 'drivers_license_front',
    NATIONAL_ID_BACK: 'national_id_back',
    NATIONAL_ID_FRONT: 'national_id_front',
    PASSPORT: 'PASSPORT',
    STATUTO: 'STATUTO',
    VISURA: 'VISURA',
  },
});

const ENTITY = Object.freeze({
  TYPE: {
    COMPANY: 'COMPANY',
    INDIVIDUAL: 'INDIVIDUAL',
  },
});

const ICONS = Object.freeze({
  [APPROVAL_KEY.COMPLETED]: mdiThumbUpOutline,
  [APPROVAL_KEY.APPROVED]: mdiTimerSand,
  [APPROVAL_KEY.REJECTED]: mdiThumbDownOutline,
  [APPROVAL_KEY.TODO]: mdiClipboardEditOutline,
  [ENTITY.TYPE.COMPANY]: mdiOfficeBuildingOutline,
  [ENTITY.TYPE.INDIVIDUAL]: mdiAccountOutline,
});

const LABELS = Object.freeze({
  [DOCUMENT.TYPE.DRIVERS_LICENSE_BACK]: 'Driver\'s License - Back',
  [DOCUMENT.TYPE.DRIVERS_LICENSE_FRONT]: 'Driver\'s License - Front',
  [DOCUMENT.TYPE.NATIONAL_ID_BACK]: 'Identity Card - Back',
  [DOCUMENT.TYPE.NATIONAL_ID_FRONT]: 'Identity Card - Front',
  [DOCUMENT.TYPE.PASSPORT]: 'Passport',
  [DOCUMENT.TYPE.STATUTO]: 'Statuto',
  [DOCUMENT.TYPE.VISURA]: 'Visura',
  [ENTITY.TYPE.COMPANY]: 'Company',
  [ENTITY.TYPE.INDIVIDUAL]: 'Individual',
});

export default Object.freeze({
  APPROVAL_KEY,
  APPROVAL_STATUS_CONFIG,
  DOCUMENT,
  ENTITY,
  ICONS,
  LABELS,
});
